/**
 * Normalizes GET api/Document/get-document-revision-info:
 * envelope { isViewCopyExists, results } vs legacy flat / documentRevision wrapper.
 */

export function normalizeDocumentRevisionInfoResponse(data) {
  if (!data || typeof data !== "object") {
    return {
      revision: {},
      /** @type {boolean | null} */
      isViewCopyExists: null,
    };
  }
  const hasEnvelope =
    Object.prototype.hasOwnProperty.call(data, "results") ||
    Object.prototype.hasOwnProperty.call(data, "isViewCopyExists");

  if (hasEnvelope) {
    const results = data.results;
    const revision =
      results && typeof results === "object"
        ? results.documentRevision ?? results
        : {};
    const flag = data.isViewCopyExists;
    return {
      revision,
      isViewCopyExists: typeof flag === "boolean" ? flag : null,
    };
  }

  return {
    revision: data.documentRevision ?? data,
    isViewCopyExists: null,
  };
}
